import React, { useEffect, useState } from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Button from "../components/Button/Button.js";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const uid = useStore((state) => state.uid);
  const character = useStore((state) => state.character);

  if (!character) return null;

  return (
    <div className={`Page${props.className ? " " + props.className : ""}`}>
      <h1>{getLocalized("texts", "DeineVerkleidung")}</h1>
      {/* <div>{getLocalized("character", "Name")}</div> */}
      {getLocalized("character", "Verkleidung")?.length > 0 &&
        getLocalized("character", "Verkleidung")?.map((block, index) => {
          if (block.__component === "blocks.text-block")
            return <BlocksRenderer key={index} content={block.text} />;

          if (block.__component === "blocks.media-block")
            return (
              <div key={index}>
                {block.media &&
                  block.media?.data?.attributes?.mime.includes("image") && (
                    <img
                      src={
                        process.env.REACT_APP_CMS_URL +
                        (block.media?.data?.attributes?.formats?.small?.url ||
                          block.media?.data?.attributes?.url)
                      }
                    />
                  )}

                {block.mediaText && block.mediaText.length > 0 && (
                  <BlocksRenderer content={block.mediaText} />
                )}
              </div>
            );
        })}
    </div>
  );
};

export default Page;
